import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ingestApi } from "../../../api";
import { SourceCreate, SourceOrgCategory } from "../../../generated/ingest-api";

export function useCreateSource(category: SourceOrgCategory, orgId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (sourceCreate: SourceCreate) =>
      ingestApi.createSource(sourceCreate),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["listSources", category, orgId],
      });
    },
  });
}
